export default "__VITE_ASSET__gDG6k1X9__"